import styled from 'styled-components';
import { gtagEvent, vars } from '@agendor/ui';

const Wrapper = styled.footer`
    min-height: ${vars.footerMinHeight};
    border-top: 1px solid ${vars.dividerColor};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: ${vars.backgroundColorDark};
    box-sizing: border-box;
    padding-bottom: env(safe-area-inset-bottom, 0);
`;

const Content = styled.div`
    padding: 0 24px;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    height: 100%;
    min-height: ${vars.footerMinHeight};

    @media (max-width: 480px) {
        padding: 16px 24px;
        flex-direction: column;
        align-items: center;
        gap: 16px;
    }
`;

const Links = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;

    a {
        text-decoration: none;
        color: inherit;
    }

    a:hover {
        text-decoration: underline;
    }

    @media (max-width: 480px) {
        justify-content: center;
    }
`;

const Separator = styled.span`
    user-select: none;
`;

export default function Footer() {
    return (
        <Wrapper id="app-footer">
            <Content>
                <span>© {new Date().getFullYear()} OrganizaBot.</span>
                <Links>
                    <a
                        href="https://organizabot.com/privacy"
                        target="_blank"
                        rel="noreferrer"
                        onClick={() => gtagEvent('footer_privacy_click')}
                    >
                        Privacidade
                    </a>
                    <Separator>•</Separator>
                    <a
                        href="https://organizabot.com/terms"
                        target="_blank"
                        rel="noreferrer"
                        onClick={() => gtagEvent('footer_terms_click')}
                    >
                        Termos
                    </a>
                </Links>
            </Content>
        </Wrapper>
    );
}
